<template>
  <div class="p-4">
    <l-container class="mb-4">
      <l-container-title
        slot="toolbar"
        text="Plot"
        icon="network-wired"
        color="bg-pastel-purple"
      />
    </l-container>

    <l-l-selection @click="onSelectionClick"/>

    <div is="SensorPlot" :sensor=item :selection=selection  v-for="item in sensors" :key="item.name"></div>

  </div>
</template>

<script>

const FilteringOptions= Object.freeze({ last24h: 'last24h', olddata: 'olddata', newdata: 'newdata', daterange: 'daterange'});

import ContextMenu from "./context.menu";
import Notify from "@/helpers/notify";
import { LButton } from "@/components/forms";
import ObservationsService from "../../helpers/apiservices/observations/observations.service";
import LLSelection from "../../views/viewer/LLSelection";
import * as moment from "moment";
import SensorPlot from './SensorPlot';

export default {
  name: "plot",
  props: [
      'sensors'
  ],
  data() {
    return {
        error: "",
        loading: false,
        FilteringOptions,
        filtering: FilteringOptions.newdata,
        selection:{
          filterDateFrom: moment.utc().subtract(24,"hours").unix(), 
          filterDateTo: moment().unix(),
          filtering: FilteringOptions.last24h
        }
        
    };
  },
  components: {
    LButton,
    LLSelection,
    SensorPlot 
  },

  mounted() {
  },

  methods: {
    dataFieldType: function (n) {
        return n === this.filtering ? 'warning' : 'success';
    },
    async onSelectionClick(selections) {   

      //trigger only one update
      let s = {
        filterDateFrom: selections.from,
        filterDateTo: selections.to,
        filtering : selections.filtering
      }
      this.selection = s;
    }
  }
};
</script>



